import { observable, decorate } from 'mobx';
import _ from 'lodash';

class StockState {
	Stocks = [];
	IsSendRequest = false;

	Stock = undefined;
	Products = [];
	Semimanufactures = {};
	ButtonLoading = false;
	ErrorCode = "";
	SuccessSave = false;

	sCounter = 0;
	
	TypeDummy = { Type : -1, Group : [] }
	SectionDummy = { SectionId : -1, Group : [] }
	ProductDummy = {
		Id : -1,
		ProductId : -1,
		Count : "",
		UnitName : "",
		Revision : false,
		NotRelease : false
	}
	DayDummy = {
		Id : -1,
		Day : "",
		Count : ""
	}

	SemiDummy = {
		Count: "",
		Day: [],
		EndTime: "",
		Id: -1,
		Product: "",
		ProductId: -1,
		Section: "",
		SectionId: -1,
		StartTime: "",
		UnitName: ""
	}

	/**
	 * Разбор данных от сервера со списком складов
	 * @param {object} data 
	 */
	setStocks(data) {
		this.Stocks = data.Success ? data.Stocks : [];
		this.IsSendRequest = true;
	}
	/**
	 * Разбор данных от сервера со складом
	 * @param {object} stock 
	 */
	setStock (stock) {
		var store = this;

		this.Stock = _.isUndefined(stock) ? stock : _.omit(_.clone(stock), 
			["Products", "Semimanufactures", "Success", "ErrorCode"]);
		this.Products = {};
		this.Semimanufactures = {};
		
		if (!_.isUndefined(stock)) {
			var types = _.isNull(stock.Products) ? [] : _.groupBy(stock.Products, "Type");

			_.each([1,2], function (type) {
				var groupP = _.isUndefined(types[type]) ? {"-1" : []}
					: _.groupBy(types[type], "SectionId");

				store.Products[parseInt(type, 10)] = _.map(groupP, function (group, section) {
					return {
						SectionId : _.isUndefined(section) ? -1 : parseInt(section, 10),
						Group : _.isEmpty(group) || _.isUndefined(group) ? [_.clone(store.ProductDummy)] : group
					}
				});
			});

			var semiAll = _.isNull(stock.Semimanufactures) ? [_.clone(this.SemiDummy)] : stock.Semimanufactures;
		
			this.Semimanufactures = _.map(_.groupBy(semiAll, "SectionId"), function(group) {
				return { SectionId : group[0].SectionId, Group : group }
			});
		}

		this.ErrorCode = "";
		this.ButtonLoading = false;
		this.SuccessSave = false;
		this.sCounter = 0;
	}

	/**
	 * Сбор данных с формы редактирования конфигурации
	 * @param {string} id название параметра
	 * @param {string} value значение параметра
	 * @param {number} index порядковый номер продукта
	 * @param {number} group порядковый номер раздела
	 * @param {number} type тип раздела
	 * @param {string} unit ЕИ выбранного продукта
	 */
	collectProducts (id, value, index, group, type, unit) {
		if (_.isUndefined(index)) {
			if (/SectionId/.test(id)) this.Products[type][group].SectionId = value;
		} else {
			if (/Revision/.exec(id)) this.Products[type][group].Group[index].Revision = value;
			else if (/NotRelease/.exec(id)) this.Products[type][group].Group[index].NotRelease = value;
			else this.Products[type][group].Group[index][id] = value;

			if (/ProductId/.test(id)) this.Products[type][group].Group[index].UnitName = unit;
		}
	}

	/**
	 * Сбор данных с формы редактирования заготовок
	 * @param {string} id название параметра
	 * @param {string} value значение параметра
	 * @param {number} index порядковый номер продукта
	 * @param {number} group порядковый номер раздела
	 * @param {object} product информация о выбранном продукте
	 */
	collectSemi (id, value, index, group, product) {
		if (_.isUndefined(index)) {
			if (/SectionId/.test(id)) this.Semimanufactures[group].SectionId = value;
		} else {
			if (/Day/.test(id)) {
				var day = parseInt(id.split("_")[1], 10),
					days = this.Semimanufactures[group].Group[index].Day;

				if (value) this.Semimanufactures[group].Group[index].Day = _.concat(days, day);
				else this.Semimanufactures[group].Group[index].Day = _.remove(days, day);
			} else if (/Time/.test(id))	{
				this.Semimanufactures[group].Group[index].StartTime = value.StartTime;
				this.Semimanufactures[group].Group[index].EndTime = value.EndTime;
			}
			else this.Semimanufactures[group].Group[index][id] = value;

			if (/ProductId/.test(id) && !_.isEmpty(product))
				this.Semimanufactures[group].Group[index].UnitName = product.UnitNet;
		}
	}

	/**
	 * Сбор данных с начтройками склада для отправки на сервер
	 * @returns {object}
	 */
	getSaveData () {
		var data = { Id : this.Stock.Id },
			products = _.flatten(_.map(_.flatMap(this.Products), "Group")),
			semi = _.flatten(_.map(this.Semimanufactures, "Group")),
			index = 0;

		_.each(products, function (v) {
			var name = "Products." + index + ".";

			if (v.ProductId !== -1 && v.ProductId !== "") {
				data[name + "Id"] = v.Id;
				data[name + "ProductId"] = v.ProductId;
				data[name + "Count"] = v.Count;
				data[name + "Revision"] = v.Revision;
				data[name + "NotRelease"] = v.NotRelease;
				index++;
			}
		});
		
		index = 0;

		_.each(semi, function (v) {
			var name = "Semimanufactures." + index + ".";

			if (v.ProductId !== -1 && v.ProductId !== "") {
				data[name + "Id"] = -1;
				data[name + "ProductId"] = v.ProductId;
				data[name + "Count"] = v.Count;
				data[name + "Day"] = v.Day.join(",");
				data[name + "StartTime"] = v.StartTime;
				data[name + "EndTime"] = v.EndTime;
				index++;
			}
		});

		return data;
	}
}
decorate(StockState, {
	Stock: observable,
	Products: observable,
	Semimanufactures: observable,

	Stocks: observable,
	IsSendRequest: observable,

	ButtonLoading: observable,
	ErrorCode: observable,
	SuccessSave: observable
});
export const stockState = new StockState();
